module.exports = __webpack_public_path__ + "static/media/oppidum_tn.aff33315.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/oppidum_tn.jpg
// module id = 744
// module chunks = 0